import { NavLink } from "react-router-dom";

const HeaderInvestorDashboard = () => {
  return (
    <header>
      <section className={"headerPart"}>
        <div className="container-fluid">
          <div className="headerInn">
            <ul className="headerUl">
              <li>
                <NavLink to="/investor-dashboard/investordashboard">
                  Summary
                </NavLink>
              </li>
              <li>
                <NavLink to="/investor-dashboard/investanalysis">
                  Investment Note Details
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section className="btmheader">
        <div className="container-fluid">
          <p className="headerPara">
            *All amounts below are denominated in Singapore Dollars (SGD) unless
            otherwise stated.
          </p>
        </div>
      </section>
    </header>
  );
};

export default HeaderInvestorDashboard;
